import consumer from '../channels/consumer'

let subscription = null

export function subscribeDigibord(weekPlanId) {
  unsubscribeDigibord()

  subscription = consumer.subscriptions.create(
    { channel: 'DigibordChannel', week_plan_id: weekPlanId },
    {
      connected() {
        console.log('DigibordChannel connected', weekPlanId)
      },
      disconnected() {
        console.log('DigibordChannel disconnected')
      },
      received(data) {
        document.dispatchEvent(new CustomEvent('digibord:updated', { detail: data }))
      },
    }
  )
}

export function unsubscribeDigibord() {
  if (subscription) {
    subscription.unsubscribe()
    subscription = null
  }
}
